import { Paper, styled } from '@mui/material';

export const StyledGradeBookWeekDayWrap = styled(Paper)(({ theme }) => ({
	display: 'flex',
	borderRadius: '20px',
	padding: '16px',
	gap: '8px',
	overflow: 'hidden',

	[theme.breakpoints.down('sm')]: {
		flexDirection: 'column',
		borderRadius: '10px',
		padding: '8px',
	},
}));

export const StyledGradeBookWeekDaySection = styled(Paper)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '10px',
	padding: '9px',
	borderRadius: '10px',

	[theme.breakpoints.up('sm')]: {
		writingMode: 'vertical-lr',
		rotate: '180deg',
	},
}));
